<script setup>
import axios from "axios";

const props = defineProps(
    ['group']
)

const callLogging = async (groupId, tel) => {
    try {
        const params = new URLSearchParams();
        params.append('group_id', groupId);
        params.append('tel', tel);
        const response = axios.get('/api/logging-call', {
            params
        });
    } catch (error) {}
}

const item = props.group;
</script>

<template>
    <div class="p-group-contact">
        <p class="p-group-contact__txt">
            初診ご予約受付中
        </p>
        <div class="p-group-contact__inner">
            <div class="p-group-contact__btn c-btn--pink is-tel" :class="item.reserve_flag==2 ? 'is-full' : ''">
                <a v-if="item.instrumentation_tel" :href="'tel:' + item.instrumentation_tel" @click="callLogging(item.id, item.instrumentation_tel)">
                    <span>電話番号</span>
                    <span>{{item.instrumentation_tel}}</span>
                </a>
                <a v-else-if="!item.instrumentation_tel && item.tel" :href="'tel:' + item.tel" @click="callLogging(item.id, item.tel)">
                    <span>電話番号</span>
                    <span>{{item.tel}}</span>
                </a>
            </div>
            <div v-show="item.reserve_flag!=2" class="p-group-contact__btn c-btn--pink is-mail">
                <a :href="'/reserve/' + item.id + '/'">
                    <span>オンライン予約</span>
                </a>
            </div>
        </div>
    </div>
</template>
